import { ReactNode } from 'react';
import { Avatar, Button, Content, H2, Stack, Text } from '@kinesis/bungle';
import { Center } from '@/components/center';
import { KinesisLogo } from '@/components/kinesis-logo';

// The faces of the share landing screen: pending (accept/decline), already
// claimed, expired, not found, and "log in to continue". Mirrors the
// invitation-accept page's message card.
const ShareMessage = (props: ShareMessageProps) => {
  const { title, children, actions = [], organisation } = props;
  return (
    <Content background='white' borderRadiusSize='large' width={304}>
      <Content padding='large' sizing='fill-container' paddingMode='equal'>
        <Stack space='medium'>
          <Center>
            <KinesisLogo />
          </Center>
          {/* The owning organisation's avatar. An unresolved owner (no name)
              renders the generic placeholder initial instead — the avatar
              itself is never skipped. */}
          {organisation && (
            <Center>
              <Avatar
                alt={
                  organisation.name
                    ? `${organisation.name} logo`
                    : 'Organisation logo'
                }
                image={organisation.avatar}
                magnitude='medium'
                variant='organisation'
              >
                {organisation.name?.slice(0, 1) ?? 'I'}
              </Avatar>
            </Center>
          )}
          <Center>
            <H2>{title}</H2>
          </Center>
          <Text>{children}</Text>
          {actions.map((action) => (
            <Button
              key={action.label}
              display='block'
              variant={action.variant}
              loading={action.loading}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </Stack>
      </Content>
    </Content>
  );
};

export type ShareMessageAction = {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary';
  loading?: boolean;
};

export type ShareMessageProps = {
  title: string;
  children?: ReactNode;
  actions?: ShareMessageAction[];
  organisation?: { name?: string; avatar?: string };
};

export { ShareMessage };
